var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSuperAdmin)?_c('div',[(_vm.thirdPartyMenuDisabled)?_c('status-badge',{staticClass:"mb-1",attrs:{"tone":"critical"}},[_vm._v(_vm._s(_vm.$t('tp_diff.order_menu_disabled')))]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }